import React, { useEffect, useState } from 'react';
import { Sparkles, Zap, Clock } from 'lucide-react';
import {
  isDiscountActive,
  DISCOUNT_PERCENT,
  DISCOUNT_NAME,
  DISCOUNT_DATE_LABEL,
} from '../utils/discount';

const pad = (n) => String(n).padStart(2, '0');

const getCountdown = () => {
  const now = new Date();
  const endOfDay = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59, 999);
  const diff = Math.max(endOfDay.getTime() - now.getTime(), 0);
  const hours = Math.floor(diff / 3_600_000);
  const minutes = Math.floor((diff % 3_600_000) / 60_000);
  const seconds = Math.floor((diff % 60_000) / 1000);
  return { hours, minutes, seconds };
};

const DiscountBanner = () => {
  const [active, setActive] = useState(isDiscountActive());
  const [countdown, setCountdown] = useState(getCountdown());

  useEffect(() => {
    if (!active) return undefined;
    const id = setInterval(() => {
      const stillActive = isDiscountActive();
      setActive(stillActive);
      setCountdown(getCountdown());
    }, 1000);
    return () => clearInterval(id);
  }, [active]);

  if (!active) return null;

  return (
    <div
      className="mb-12 mx-auto max-w-5xl bg-gradient-to-r from-red-600 via-rose-600 to-pink-600 rounded-2xl p-6 md:p-8 shadow-2xl text-white relative overflow-hidden"
      data-testid="discount-banner"
    >
      <div className="absolute -top-6 -right-6 h-24 w-24 rounded-full bg-yellow-300/20 blur-2xl"></div>
      <div className="flex flex-col md:flex-row items-center justify-between gap-6 relative">
        <div className="flex items-center gap-5 text-center md:text-left">
          <Zap className="h-12 w-12 md:h-14 md:w-14 flex-shrink-0 fill-yellow-300 text-yellow-300 drop-shadow-lg" />
          <div>
            <div className="inline-flex items-center gap-1 bg-yellow-300 text-red-700 px-3 py-1 rounded-full text-xs font-extrabold uppercase tracking-wider mb-2">
              <Sparkles className="h-3 w-3" />
              {DISCOUNT_NAME}
            </div>
            <h3 className="text-2xl md:text-3xl font-extrabold mb-1">
              {DISCOUNT_PERCENT}% Off All Books — Today Only!
            </h3>
            <p className="text-white/95 text-sm md:text-base">
              Discount auto-applied at checkout. Ends at midnight, your local time.
            </p>
          </div>
        </div>

        <div className="flex flex-col items-center bg-black/25 backdrop-blur-sm border border-white/20 rounded-xl px-5 py-3 min-w-[180px]">
          <div className="flex items-center gap-1 text-xs uppercase tracking-widest text-yellow-200 mb-1">
            <Clock className="h-3 w-3" />
            Ends in
          </div>
          <div className="font-mono text-2xl font-bold tabular-nums" data-testid="discount-countdown">
            {pad(countdown.hours)}:{pad(countdown.minutes)}:{pad(countdown.seconds)}
          </div>
          <div className="text-[10px] text-yellow-100/80 mt-0.5">{DISCOUNT_DATE_LABEL}</div>
        </div>
      </div>
    </div>
  );
};

export default DiscountBanner;
